export default __webpack_public_path__ + "static/media/placeholder.da514c17.png";